import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useRef, } from 'react';
const styles = {
    container: {
        display: 'flex',
    },
    label: {
        lineHeight: 2,
        userSelect: 'none',
        flex: '2',
    },
    inputContainer: {
        flex: '4',
        display: 'flex',
        justifyContent: 'flex-start',
    },
    input: {
        height: '100%',
        width: '100px',
        borderRadius: '5px',
        border: '0.55px solid #c7c7c7',
        margin: '0px 5px 0px 5px',
        textAlign: 'center',
    },
};
const NumberInput = forwardRef(({ label, name, defaultValue = 0, style = { label: {}, input: {}, container: {}, inputContainer: {} }, onChange = () => null, onInput = () => null, pattern = '^d*(.d{0,2})?$', step = 'any', min = 'any', max = 'any', }, ref) => {
    const localRef = useRef(null);
    const changeHander = useCallback((e) => {
        if (e.target.checkValidity()) {
            const value = Number(e.target.value === '' ? defaultValue : e.target.value);
            onChange({
                ...e,
                target: { ...e.target, name: e.target.name, value },
            });
        }
        else {
            const _ref = ref || localRef;
            _ref.current.value = Number(defaultValue);
        }
    }, [defaultValue, onChange, ref]);
    return (_jsxs("div", { style: { ...styles.container, ...style.container }, children: [_jsx("span", { style: { ...styles.label, ...style.label }, children: label }), _jsx("div", { style: { ...styles.inputContainer, ...style.inputContainer }, children: _jsx("input", { ref: ref || localRef, name: name, style: { ...styles.input, ...style.input }, type: "number", pattern: pattern, defaultValue: defaultValue, step: step, onChange: changeHander, onInput: onInput, min: min, max: max }, defaultValue) })] }));
});
export default NumberInput;
